type AlertVariant = 'error' | 'success' | 'warning' | 'info'

interface AlertProps {
  variant: AlertVariant
  children: React.ReactNode
  className?: string
}

const variantClasses: Record<AlertVariant, string> = {
  error:   'bg-red-50 border-red-300 text-red-800',
  success: 'bg-green-50 border-green-300 text-green-800',
  warning: 'bg-amber-50 border-amber-300 text-amber-800',
  info:    'bg-primary-50 border-primary-200 text-primary-800',
}

export function Alert({ variant, children, className = '' }: AlertProps) {
  return (
    <div
      role="alert"
      className={[
        'rounded-md border px-4 py-3 text-sm',
        variantClasses[variant],
        className,
      ].join(' ')}
    >
      {children}
    </div>
  )
}
